import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner, Modal } from "react-bootstrap";
import "./_Diary_NoticeResponse.scss";


class DiaryResponseModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            seenUnseenId: "0",
            count: 0,
            viewStatus: false,
            dataClear: 0,
        }
    }

    handleSelect(val) {
        console.log("mamamamam", val);
        this.setState({
            seenUnseenId: val == "0" ? "0" : "1"
        })
    }



    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({ seenUnseenId: "0", dataClear: 1 })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    };



    render() {
        console.log("seeen", this.state);

        let studentCreation = this.props.stateData?.studentDairyNoticeCreationDetails.filter((item) => item.dairyAssigment_id == this.props.stateData.deleteId);
        let seenStudents = this.props.stateData.studentDairyNoticeSubmissionDetails.filter((item) => item.status == 1 && item.dairy_assignment_id == this.props.stateData.deleteId);


        let totalStudents = this.props.stateData.studentDiaryNoticeViewStatus;

        let nonseenStudents = [];

        if (studentCreation.length > 0) {
            let seenStudentsdata = seenStudents.map((item) => item.edu_student_id).toString()
            nonseenStudents = totalStudents.filter((item) => studentCreation[0].exam_id.includes(item.exam_id)).filter((item1) => studentCreation[0].class_id.includes(item1.class_id)).filter((item2) => studentCreation[0].section_ids.includes(item2.section_id)).filter((item3) => !seenStudentsdata.includes(item3.edu_student_id));

            console.log("after", seenStudentsdata);
        }

        let studentFilterData = [];
        if (this.state.seenUnseenId == "0") {
            studentFilterData = nonseenStudents.filter((item) => item.status == "0");
        } else if (this.state.seenUnseenId == "1") {
            studentFilterData = seenStudents.filter((item) => item.status == "1")
        }
        console.log("studentFilterData", studentFilterData);

        return (
            <Modal {...this.props} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Student Status Details</Modal.Title>
                </Modal.Header>
                <Container fluid className='studentDetails'>
                    <Modal.Body className=" ">
                        <Row>
                            <Col sm={6}>
                                <Card className={this.state.seenUnseenId == "0" ? "active block_view" : "block_view"}
                                    name="SeenUnStatus" id="0" onClick={() => this.handleSelect("0")}>
                                    <Card.Body>
                                        <h6 className="text-center"><span className="title_alignment text-center mr-2">  Un-Seen <i className="fa fa-eye-slash text-primary mr-2" />{nonseenStudents.length}</span></h6>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm={6}>
                                <Card className={this.state.seenUnseenId == "1" ? "active block_view" : "block_view"}
                                    name="SeenUnStatus" id="1" onClick={() => this.handleSelect("1")}
                                >
                                    <Card.Body>
                                        <h6 className="text-center"><span className='title_alignment text-center mr-2'>  Seen   <i className="fas fa-eye text-primary mr-2" />{seenStudents.length}</span></h6>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            {
                                nonseenStudents.length > 0 ? (
                                    <Col sm={12} className='mt-3'>
                                        {
                                            this.state.seenUnseenId == "0" ? (
                                                <>
                                                    {
                                                        nonseenStudents.length > 0 ? (
                                                            <Table className="table  table-bordered table-hover">
                                                                <thead style={{ backgroundColor: "#213046 ", color: "white", }}>
                                                                    <tr>
                                                                        <th>Sno</th>
                                                                        <th>Roll No</th>
                                                                        <th>Student Name</th>
                                                                        <th>Parent Name</th>
                                                                        <th>Parent Mobile</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody style={{ cursor: "pointer", }} className='tableData'>
                                                                    {
                                                                        nonseenStudents.map((item, index) => {
                                                                            return (
                                                                                <>
                                                                                    <tr key={index}>
                                                                                        <td>{index + 1}</td>
                                                                                        <td>{item?.roll_no}</td>
                                                                                        <td>{item?.student_name}</td>
                                                                                        <td>{item?.parent_name}</td>
                                                                                        <td>{item?.parent_mobile}</td>
                                                                                    </tr>
                                                                                </>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </Table>
                                                        ) : (
                                                            <Row>
                                                                <Col xs={12} md={12} sm={12} className="d-flex align-items-center justify-content-md-center">
                                                                    <h4 className='mt-3 text-center'><span className="text-danger"> * </span>  No data available</h4>
                                                                </Col>
                                                            </Row>
                                                        )
                                                    }
                                                </>
                                            ) : (
                                                this.state.seenUnseenId == "1" ? (
                                                    <>
                                                        {
                                                            seenStudents.length > 0 ? (


                                                                <Table className="table  table-bordered table-hover ">
                                                                    <thead style={{ backgroundColor: "#191970", color: "white" }}>
                                                                        <tr>
                                                                            <th>S no</th>
                                                                            <th>Roll No</th>
                                                                            <th>Student Name</th>
                                                                            <th>Parent Name</th>
                                                                            <th>Parent Mobile</th>
                                                                            <th>Comments</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody style={{ cursor: "pointer" }}>
                                                                        {
                                                                            seenStudents.map((item, index) => (
                                                                                item.status == "1" ? (
                                                                                    <tr key={index}>
                                                                                        <td>{index + 1}</td>
                                                                                        <td>{item?.roll_no}</td>
                                                                                        <td>{item?.student_name}</td>
                                                                                        <td>{item?.parent_name}</td>
                                                                                        <td>{item?.parent_mobile}</td>
                                                                                        <td>{item?.comments}</td>
                                                                                    </tr>
                                                                                ) : null
                                                                            ))
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            ) : (
                                                                <Row>
                                                                    <Col xs={12} md={12} sm={12} className="d-flex align-items-center justify-content-md-center">
                                                                        <h4 className='mt-3 text-center'><span className="text-danger"> * </span>  No data available</h4>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        }
                                                    </>
                                                ) : ""
                                            )
                                        }
                                    </Col>
                                ) : (
                                    <h4 className='No_Data mt-3'><span className="text-danger"> * </span>  No data available</h4>
                                )
                            }
                        </Row>
                    </Modal.Body>
                </Container>
            </Modal>
        )
    }
}
export default DiaryResponseModal;